<script>
import LegoBtn from "@/components/Lego/LegoBtn.vue";
import AddBtn from "@/components/buttons/AddBtn.vue";
import LegoDropzone from "@/components/Lego/LegoDropzone.vue";
import lodash from "lodash";

export default {
  props: {
    cardId: {
      type: String,
      required: false,
    },
  },
  components: {
    LegoBtn,
    AddBtn,
    LegoDropzone,
  },
  async mounted() {
    this.$nextTick(() => {
      const container = this.$refs.adjuntosContainer;
      if (container) {
        container.addEventListener("scroll", this.handleScrollAdjuntos);
      }
    });
  },

  watch: {
    // Observar cambios en cardId para cargar archivos cuando esté disponible
    cardId: {
      immediate: true,
      async handler(newCardId) {
        if (newCardId && newCardId !== this.currentCardId) {
          this.currentCardId = newCardId;
          await this.$nextTick();
          await this.loadAttachedFiles();
        }
      },
    },
  },
  beforeDestroy() {
    const container = this.$refs.adjuntosContainer;
    if (container) {
      container.removeEventListener("scroll", this.handleScrollAdjuntos);
    }
  },
  computed: {
    card() {
      const card = this.$store.state.lego.card;
      if (!card || !card.id) {
        return {
          id: null,
          title: "",
          assignments: [],
          paginatedAttachedFiles: {
            items: [],
            total: 0,
            nextCursor: null,
            hasMore: false,
          },
        };
      }
      return card;
    },
    paginatedAttachedFiles() {
      if (!this.card || !this.card.paginatedAttachedFiles) {
        return {
          items: [],
          total: 0,
          nextCursor: null,
          hasMore: false,
        };
      }
      return this.card.paginatedAttachedFiles;
    },
    filterArchivos() {
      const items =
        this.paginatedAttachedFiles && this.paginatedAttachedFiles.items
          ? this.paginatedAttachedFiles.items
          : [];
      const filtrados = items.filter((archivo) => {
        return (
          archivo.name.includes(this.filterIncludes) &&
          (this.filterSelected
            ? archivo.typeFile === this.filterSelected
            : true)
        );
      });
      return filtrados;
    },
    pathNewAttachmentFile() {
      return `Lego/Tablero/${this.$route.params.boardId}/card/${this.cardId}/adjuntos`;
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    showEmpty() {
      if (this.paginatedAttachedFiles && this.paginatedAttachedFiles.items) {
        if (this.paginatedAttachedFiles.items.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    optionsTypeFile() {
      if (this.paginatedAttachedFiles && this.paginatedAttachedFiles.items) {
        const aux = this.paginatedAttachedFiles.items.map(
          (file) => file.typeFile
        );
        return lodash.uniq(aux);
      } else {
        return [];
      }
    },
    canUploadFiles() {
      const roleLevel = this.$store.state.lego.currencyRole.level;
      const assignments = this.card.assignments
        ? this.card.assignments.map((a) => a.personaId)
        : [];
      const userId = this.userLoggedIn.id;

      // Si no hay rol definido, no puede subir archivos
      if (!roleLevel) {
        return false;
      }

      // Los invitados no pueden hacer modificaciones
      if (roleLevel > 3) {
        return false;
      }

      // Si es colaborador (roleLevel > 2) debe estar asignado a la tarea
      if (roleLevel > 2 && !assignments.includes(userId)) {
        return false;
      }

      return true;
    },
    isLoadingAttachedFiles() {
      return this.$store.state.lego.isLoadingAttachedFiles;
    },
  },
  data() {
    return {
      captureDataIsActive: false,
      nameNewAttachedFile: "",
      filterSelected: "",
      filterIncludes: "",
      currentCardId: null,
    };
  },

  methods: {
    async loadAttachedFiles() {
      try {
        if (!this.cardId) {
          return;
        }

        // Verificar si la tarjeta está cargada en el store
        const storeCard = this.$store.state.lego.card;
        if (!storeCard || !storeCard.id || storeCard.id !== this.cardId) {
          // Esperar un poco por si LegoViewInModalProcess está cargando la tarjeta
          await this.$nextTick();
          await new Promise((resolve) => setTimeout(resolve, 100));

          // Verificar nuevamente después de esperar
          const storeCardAfterWait = this.$store.state.lego.card;
          if (
            !storeCardAfterWait ||
            !storeCardAfterWait.id ||
            storeCardAfterWait.id !== this.cardId
          ) {
            // Si aún no está, cargar la tarjeta (caso de refresh o navegación directa)
            await this.$store.dispatch("lego/getAndSetCard", this.cardId);
          }
        }

        await this.$store.dispatch("lego/loadMoreAttachedFiles", {
          cardId: this.cardId,
        });
      } catch (error) {
        console.error("Error cargando archivos adjuntos:", error);
      }
    },

    handleScrollAdjuntos() {
      const container = this.$refs.adjuntosContainer;
      if (!container) return;

      const threshold = 100; // px antes del final
      const { scrollTop, scrollHeight, clientHeight } = container;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;

      if (
        isNearBottom &&
        this.paginatedAttachedFiles &&
        this.paginatedAttachedFiles.hasMore &&
        !this.$store.state.lego.isLoadingAttachedFiles
      ) {
        this.$store.dispatch("lego/loadMoreAttachedFiles", {
          cardId: this.cardId,
        });
      }
    },
    async callbackAfterSubmitNewFile(self) {
      if (!this.canUploadFiles) {
        this.$swal.fire({
          icon: "error",
          title: "Error!",
          text: "No tienes permisos para cargar archivos en esta tarea.",
        });
        return;
      }

      const file = {
        legoCardId: this.cardId,
        name: this.nameNewAttachedFile,
        createdById: this.userLoggedIn.id,
        pathFile: self.pathAfterSaveInRemote,
        typeFile: self.dotExtension,
      };
      // console.log("file", file);
      await this.$store.dispatch("lego/addAttachedFile", file);
    },
    cancelNewAttachedFile(onCancel) {
      this.captureDataIsActive = false;
      onCancel();
    },
    stylesBackgroundColorByFile(typeFile) {
      switch (typeFile) {
        case ".pdf":
          return {
            backgroundColor: "#ff7675",
          };
        case ".docx":
          return {
            backgroundColor: "#74b9ff",
          };
        case ".xlsx":
          return {
            backgroundColor: "#00b894",
          };
        case ".pptx":
          return {
            backgroundColor: "#ff7675",
          };
        default:
          return {
            backgroundColor: "#6c5ce7",
          };
      }
    },
    getUserName(file) {
      // Si el archivo fue creado por el usuario activo
      if (file.createdById === this.userLoggedIn.id) {
        return "ti";
      }

      // Si tiene información del creador
      if (file.createdBy) {
        // Si tiene nombres y apellidos
        if (file.createdBy.nombres && file.createdBy.apellidos) {
          return `${file.createdBy.nombres} ${file.createdBy.apellidos}`.trim();
        }
        // Si solo tiene nombres
        if (file.createdBy.nombres) {
          return file.createdBy.nombres;
        }
        // Si solo tiene apellidos
        if (file.createdBy.apellidos) {
          return file.createdBy.apellidos;
        }
        // Si tiene nombre completo en una sola propiedad
        if (file.createdBy.nombreCompleto) {
          return file.createdBy.nombreCompleto;
        }
        // Si tiene nombre en una propiedad diferente
        if (file.createdBy.nombre) {
          return file.createdBy.nombre;
        }
      }

      return "Usuario desconocido";
    },
    getFormattedDate(file) {
      if (file.createdAt) {
        const date = new Date(file.createdAt);
        return date.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
      return "";
    },
  },
};
</script>

<template>
  <article>
    <div>
      <p class="head-resumen">
        Archivos asociados a la tarea "{{ card.title }}"
      </p>
    </div>

    <div
      class="new-file"
      :class="{ active: captureDataIsActive }"
      v-if="canUploadFiles"
    >
      <LegoBtn @click="captureDataIsActive = true" v-if="!captureDataIsActive">
        <AddBtn /> <span>Nuevo archivo</span>
      </LegoBtn>
      <div v-else>
        <LegoDropzone
          class="wrapper-dropzone"
          :renameFile="nameNewAttachedFile"
          @rename="nameNewAttachedFile = $event"
          :callbackAfterSubmit="callbackAfterSubmitNewFile"
          :remotePath="pathNewAttachmentFile"
        >
          <div class="inputs">
            <div>
              <input
                type="text"
                class="form-control"
                v-model="nameNewAttachedFile"
                placeholder="Nombre del nuevo documento"
              />
            </div>
          </div>
          <template #btn-cancel="{ onCancel }">
            <vs-button
              class="slot-button"
              @click.prevent="cancelNewAttachedFile(onCancel)"
              danger
              >Cancelar</vs-button
            >
          </template>
        </LegoDropzone>
      </div>
    </div>

    <div class="wrapper-section-all-files">
      <header>
        <p>Todos los archivos</p>
        <div class="filtros">
          <input
            v-model="filterIncludes"
            type="text"
            class="form-control"
            placeholder="Por nombre"
          />
          <v-select
            v-model="filterSelected"
            class="lego"
            :options="optionsTypeFile"
            placeholder="Por tipo"
          />
        </div>
      </header>
      <transition name="fade">
        <div
          v-if="isLoadingAttachedFiles && !paginatedAttachedFiles.items.length"
          class="loading-container"
        >
          <div class="loading-spinner">
            <div class="spinner"></div>
            <p class="loading-text">Cargando archivos...</p>
          </div>
        </div>
        <div
          v-else-if="showEmpty && !isLoadingAttachedFiles"
          class="d-flex flex-column align-items-center p-3"
        >
          <i class="ti ti-file-search fa-5x text-muted"></i>
          <p v-if="!cardId">Esperando datos de la tarea...</p>
          <p v-else>No existen archivos asociados a ésta tarea.</p>
        </div>
      </transition>
      <div
        v-show="
          paginatedAttachedFiles.items.length > 0 ||
          (!isLoadingAttachedFiles && !showEmpty)
        "
        ref="adjuntosContainer"
        class="archivos-scroll custom-scrollbar"
      >
        <transition-group name="list" tag="div" class="archivos">
          <div
            class="wrapper-file"
            v-for="file in filterArchivos"
            :key="file.id"
          >
            <div class="file-meta-info">
              <span class="file-date" v-if="getFormattedDate(file)">{{
                getFormattedDate(file)
              }}</span>
              <span class="file-uploader"
                >Subido por {{ getUserName(file) }}</span
              >
            </div>
            <a
              :href="file.pathFile"
              target="_blank"
              class="wrapper-file--link"
              v-b-tooltip.hover
              title="Ir al archivo"
            >
              <i class="fas fa-link"></i>
            </a>
            <div
              :title="file.name"
              class="wrapper-file--info"
              :style="stylesBackgroundColorByFile(file.typeFile)"
            >
              {{
                (file.name.length > 20
                  ? file.name.substring(0, 15) + "..."
                  : file.name) + file.typeFile
              }}
            </div>
          </div>
        </transition-group>

        <!-- Indicador de carga para más archivos -->
        <div
          v-if="isLoadingAttachedFiles && paginatedAttachedFiles.items.length"
          class="loading-more-files"
        >
          <div class="loading-more-spinner">
            <div class="spinner-small"></div>
            <span class="loading-more-text">Cargando más archivos...</span>
          </div>
        </div>
      </div>

      <div
        v-if="!isLoadingAttachedFiles && paginatedAttachedFiles.items.length"
        class="load-more-files"
      >
        <div class="info-files">
          {{ paginatedAttachedFiles.items.length }} de
          {{ paginatedAttachedFiles.total }} archivos
        </div>
      </div>
    </div>
  </article>
</template>

<style scoped>
.info-files {
  align-self: end;
}

.load-more-files {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0;
  width: 100%;
}

.wrapper-dropzone :deep(.body) {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 0.5rem;
}

.wrapper-dropzone :deep(.dropzone) {
  order: 1;
  height: 38px;
  width: 150px;
}

.wrapper-dropzone :deep(.inputs) {
  order: 2;
}

.wrapper-section-all-files header {
  margin-bottom: 1rem;
}

.filtros {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.archivos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 0.5rem;
}

.archivos-scroll {
  max-height: 300px;
  overflow-y: auto;
}

.wrapper-file {
  height: 130px;
  width: 160px;
  background-color: var(--lego-dbg);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  border-radius: 0.5rem;

  .dark & {
    background-color: #18191c;
  }
}

.wrapper-file--info {
  color: #fff;
  text-align: start;
  padding: 0.2rem 0.5rem;
  width: 100%;
  max-height: 40px;
  text-wrap: wrap;
  overflow: hidden;
  border-radius: 0 0 0.5rem 0.5rem;
  font-weight: 500;
  font-size: 0.7rem;
}

.file-meta-info {
  position: absolute;
  top: 2rem;
  left: 0.5rem;
  right: 0.5rem;
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  max-width: calc(100% - 1rem);
}

.file-uploader {
  opacity: 0.8;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-height: 2.8em;
  line-height: 1.4em;
}

.file-date {
  opacity: 0.8;
}

.wrapper-file--link {
  position: absolute;
  top: 0;
  right: 0;
  color: var(--lego-gris);
  padding: 0.5rem;
}

.new-file {
  margin-bottom: 2rem;
  transition: all 0.5s;
  height: 40px;
  /* min-height: 100px; */
}

.new-file.active {
  height: 90px;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* Loading container */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  padding: 1.5rem;
}

.loading-spinner {
  text-align: center;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 0.75rem;
}

.loading-text {
  color: var(--text-progress);
  font-size: 0.875rem;
  margin: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Dark mode support */
.dark .spinner {
  border-color: rgba(255, 255, 255, 0.2);
  border-top-color: #3498db;
}

.dark .loading-text {
  color: rgba(255, 255, 255, 0.8);
}

/* Loading more files indicator */
.loading-more-files {
  display: flex;
  justify-content: center;
  padding: 1rem;
  margin-top: 1rem;
}

.loading-more-spinner {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-more-text {
  color: var(--text-progress);
  font-size: 0.8rem;
  opacity: 0.8;
}

/* Dark mode support for loading more */
.dark .spinner-small {
  border-color: rgba(255, 255, 255, 0.2);
  border-top-color: #3498db;
}

.dark .loading-more-text {
  color: rgba(255, 255, 255, 0.7);
}
</style>
